import { render, staticRenderFns } from "./TyreTagField.vue?vue&type=template&id=48ea4cb2"
import script from "./TyreTagField.vue?vue&type=script&lang=ts"
export * from "./TyreTagField.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports